var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-wrapper"},[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.getStaticText[_vm.lang].mainPage.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }